import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { UpdateChatHistoryInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const UpdateChatHistoryMutation = graphql(`
  mutation UpdateChatHistory($input: UpdateChatHistoryInput!) {
    updateChatHistory(input: $input) {
      id
      __typename
      client {
        id
        __typename
        name
        externalReference
      }
      sessionId
      messages
      createdAt
      updatedAt
    }
  }
`);

export function useUpdateChatHistory() {
  const [result, updateChatHistoryMutation] = useMutation(UpdateChatHistoryMutation);
  const [error, setError] = useState<Error | null>(null);

  const updateChatHistory = useCallback(
    async (input: UpdateChatHistoryInput) => {
      try {
        const response = await updateChatHistoryMutation({ input });
        if (response.error) {
          throw response.error;
        }
        return response.data?.updateChatHistory;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [updateChatHistoryMutation],
  );

  return { updateChatHistory, result, error };
}
